import { render, staticRenderFns } from "./Ownprices.vue?vue&type=template&id=564f1bb6&scoped=true"
import script from "./Ownprices.vue?vue&type=script&lang=js"
export * from "./Ownprices.vue?vue&type=script&lang=js"
import style0 from "./Ownprices.vue?vue&type=style&index=0&id=564f1bb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "564f1bb6",
  null
  
)

export default component.exports